import { Grid } from "@mui/material";
import React, { useEffect, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  TextField,
  Button,
  Box,
  Link,
} from "@mui/material";

import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";

import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { styled } from "@mui/material/styles";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { UploadFile } from "@mui/icons-material";
import UGTable from "../../../../Supporting files/UGTable/UGTable";
import AddNewContact from "../../../../Components/Broker/Contact/AddNewContactSP/AddNewContact";
import BulkUploadForm from "../../../../Components/Common/BulkUploadFormSP/BulkUploadForm";
// import { Get, Post } from "../../../../Supporting files/CallAPI";
import { URL_CONSTANTS } from "../../../../APIVar/URLConstants";
import SearchBarAnimation from "../../../../Components/Broker/SearchBarAnimation/SearchBox";
import DeletePopup from "../../../../Components/Common/DeletePopup/DeletePopup";
import { ALL_ROUTES } from "../../../../Routes/all_routes";
import SearchBox from "../../../../Components/Broker/SearchBarAnimation/SearchBox";
import MassUpdate from "../../Common/MassUpdate/MassUpdate";
import UGDateRangePicker from "../../../../Supporting files/UGDateRangePicker/UGDateRangePicker";
interface Props {
  addContact: boolean;
}

const Contacts: React.FC<Props> = ({ addContact }) => {
  const [uploadFile, setUploadFile] = React.useState(false);
  const [uploadFileStep, setUploadFileStep] = React.useState(1);
  const [addPolicyStatus, setAddPolicyStatus] = React.useState(false);
  const [addnewcontact, setAddNewContact] = React.useState(addContact);
  const [editContact, setEditContact] = React.useState(false);
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [massUpdate, setMassUpdate] = React.useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    // attach the event listener
    window.addEventListener("keydown", handleKeyPress);
    //get_contacts_list();
  }, []);

  const handleKeyPress = useCallback((e: any) => {
    var event = e;
    if (event.target.tagName !== "INPUT") {
      if (event.shiftKey && event.keyCode == 78) {
        setAddNewContact(true);
      }
    }
  }, []);

  //Table Data
  const [headerData, setHeaderData] = React.useState([
    {
      field: "contactId",
      headerName: "Contact ID",
      width: 100,
      check_status: true,
    },

    {
      field: "title",
      headerName: "Title",
      width: 100,
      check_status: true,
    },
    {
      field: "fullName",
      headerName: "Full Name",
      width: 200,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link
            underline="none"
            style={{
              cursor: "pointer",
              fontWeight: "400",
              color: "#2166AA",
              textDecoration: "none",
            }}
            onClick={() => {
              navigate("/ContactDetail");
            }}
          >
            {row.fullName}
          </Link>
        );
      },
    },

    {
      field: "gender",
      headerName: "Gender",
      width: 100,
      check_status: true,
    },
    {
      field: "dateOfBirth",
      headerName: "Date Of Birth",
      width: 130,
      check_status: true,
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return <span className={row.status}>{row.status}</span>;
      },
    },
    {
      field: "companyEmail",
      headerName: "Office Email",
      width: 200,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link href={row.companyEmail} target="_blank" underline="none">
            {row.companyEmail}
          </Link>
        );
      },
    },
    {
      field: "personalEmail",
      headerName: "Email",
      width: 200,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link href={row.personalEmail} target="_blank" underline="none">
            {row.personalEmail}
          </Link>
        );
      },
    },
    {
      field: "mobile",
      headerName: "Mobile",
      width: 150,
      check_status: true,
    },
    {
      field: "phone",
      headerName: "Office Phone",
      width: 180,
      check_status: true,
    },
    {
      field: "department",
      headerName: "Department",
      width: 160,
      check_status: true,
    },
    {
      field: "designation",
      headerName: "Designation",
      width: 160,
      check_status: true,
    },
    {
      field: "clientId",
      headerName: "Client ID",
      width: 100,
      check_status: true,
    },
    {
      field: "organizationName",
      headerName: "Organization Name",
      width: 200,
      check_status: true,
    },

    {
      field: "industry",
      headerName: "Industry",
      width: 160,
      check_status: true,
    },
    {
      field: "sub_industry",
      headerName: "Sub-Industry",
      width: 250,
      check_status: true,
    },
    {
      field: "address",
      headerName: "Office Address",
      width: 160,
      check_status: true,
      // renderCell: (ValueFormatterParams: any) => {
      //   const { row } = ValueFormatterParams;
      //   return (
      //     <span>
      //       {row.addressCHouse +
      //         "," +
      //         row.addressCArea +
      //         "," +
      //         row.addressCCity +
      //         "," +
      //         row.addressCState +
      //         " - " +
      //         row.addressCPincode}
      //     </span>
      //   );
      // },
    },
    {
      field: "personalAddress",
      headerName: "Personal Address",
      width: 160,
      check_status: true,
      // renderCell: (ValueFormatterParams: any) => {
      //   const { row } = ValueFormatterParams;
      //   return (
      //     <span>

      //     </span>
      //   );
      // },
    },
  ]);
  const [tableData, setTableData] = useState([
    {
      id: 1,
      contactId: "EV1001",
      title: "Mr.",
      fullName: "Vikas Saini",
      gender: "Male",
      status: "Pending",
      companyEmail: "vikas.saini@evervent.in",
      personalEmail: "vikassaini@gmail.com",
      mobile: "9787451894",
      phone: "98775456568",
      department: "Design",
      designation: "Asso. Front-end Developer",
      dateOfBirth: "12/02/1998",
      organizationName: "Evervent",
      clientId: "EV1000562",
      industry: "Software & Services",
      sub_industry: "Information Technology",
      address: "341, Industrial Area, Phase 9, Mohali, Punjab, India -160062",
      personalAddress: "",
    },
    {
      id: 2,
      contactId: "EV1002",
      status: "Active",
      title: "Mr.",
      fullName: "Vikas Saini",
      gender: "Male",
      companyEmail: "vikas.saini@evervent.in",
      personalEmail: "vikassaini@gmail.com",
      mobile: "9787451894",
      phone: "98775456568",
      department: "Design",
      designation: "Asso. Front-end Developer",
      dateOfBirth: "12/02/1998",
      organizationName: "Evervent",
      clientId: "EV10202",
      industry: "Software & Services",
      sub_industry: "Information Technology",
      address: "341, Industrial Area, Phase 9, Mohali, Punjab, India -160062",
      personalAddress:
        "341, Industrial Area, Phase 9, Mohali, Punjab, India -160062",
    },
    {
      id: 3,
      contactId: "EV1003",
      status: "Active",
      title: "Mr.",
      fullName: "Vikas Saini",
      gender: "Male",
      companyEmail: "vikas.saini@evervent.in",
      personalEmail: "vikassaini@gmail.com",
      mobile: "9787451894",
      phone: "98775456568",
      department: "Design",
      designation: "Asso. Front-end Developer",
      dateOfBirth: "12/02/1998",
      organizationName: "Evervent",
      clientId: "EV10202",
      industry: "Software & Services",
      sub_industry: "Information Technology",
      address: "341, Industrial Area, Phase 9, Mohali, Punjab, India -160062",
      personalAddress:
        "341, Industrial Area, Phase 9, Mohali, Punjab, India -160062",
    },
  ]);

  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };

  return (
    <Grid container spacing={2}>
      {/* Bulk upload */}
      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />
      <DeletePopup
        open_status={deleteStatus}
        attrName={setDeleteStatus}
        value_update={updateMasterState}
      />
      <MassUpdate
        open_status={massUpdate}
        attrName={setMassUpdate}
        value_update={updateMasterState}
      />

      <Grid item xs={6} style={{ display: "flex", alignItems: "center" }}>
        <h3 className="mb-0 mr-3">Contacts</h3>
        <SearchBox />
      </Grid>

      <Grid item xs={6} className="text-right">
        <UGDateRangePicker
          minDate={new Date()}
          maxDate={new Date()}
          placement="bottom"
        />
        <Link
          underline="none"
          className="greenBtn edit"
          onClick={() => {
            setMassUpdate(true);
          }}
        >
          Update
        </Link>
        <Link
          underline="none"
          className="blueBtn upload"
          onClick={() => {
            navigate(ALL_ROUTES.BULK_UPLOAD_PAGE);
          }}
        >
          Bulk Upload
        </Link>
        <Link
          underline="none"
          className="blueBtn edit"
          onClick={() => {
            setEditContact(true);
          }}
        >
          Edit
        </Link>

        <Link
          underline="none"
          className="greenBtn addfile"
          onClick={() => {
            navigate("/AddNewContact");
          }}
        >
          Add
        </Link>
        <Link
          underline="none"
          className="redBtn delete"
          onClick={() => {
            setDeleteStatus(true);
          }}
        >
          Remove
        </Link>
      </Grid>
      <Grid item xs={12}>
        <div style={{ height: 400, width: "100%" }}>
          <UGTable
            header_data={headerData}
            data={tableData}
            value_update={updateMasterState}
            attrName={"UGTable"}
          />
        </div>
      </Grid>
      {/* <Modal open={deleteStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                
                className="close-button"
                onClick={() => {
                  setDeleteStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link  className="md-link" underline="none">
                You are want to delete 5 Contacts.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal> */}
    </Grid>
  );
};
export default Contacts;
